import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Button from 'components/button/Button';
import messages from 'messages';
import { StoreContext } from 'index';

const ConfirmButton = ({
  children,
  confirmType,
  confirmTitle,
  confirmMessage,
  messageValues,
  confirmAcceptLabel = messages.modalConfirmRemoveAcceptButton,
  confirmCancelLabel = messages.modalConfirmRemoveCancelButton,
  mutation,
  variables,
  refetchQueries,
  update,
  onOk,
  onError,
  onClick,
  ...props
}) => {
  const { uiState } = useContext(StoreContext);
  const intl = useIntl();

  return (
    <Button
      {...props}
      onClick={e => {
        e.preventDefault();
        if (onClick) onClick();
        // @ts-ignore
        uiState.showModal({
          title: confirmTitle
            ? intl.formatMessage(confirmTitle, messageValues)
            : '',
          message: confirmMessage ? confirmMessage : '',
          values: messageValues ? messageValues : '',
          okLabel: intl.formatMessage(confirmAcceptLabel),
          dismissLabel: intl.formatMessage(confirmCancelLabel),
          type: confirmType,
          okHandler: onOk
        });
      }}
    >
      {children}
    </Button>
  );
};

export default ConfirmButton;
